module.exports = __webpack_public_path__ + "img/22.adb39a2d.gif";